// Configuration file for API endpoints
export const config = {
  // Change this to switch between local and production
  API_BASE_URL: 'https://poly-production-194f.up.railway.app', // Production
  // API_BASE_URL: 'http://localhost:8000', // Local development
};
